import { useState } from "react";

export default function Profit() {
  const [vmCount, setVmCount] = useState(0);
  const [dbCount, setDbCount] = useState(0);
  const [cloudflareCount, setCloudflareCount] = useState(0);
  const [monthlyUsers, setMonthlyUsers] = useState(0);
  const [yearlyUsers, setYearlyUsers] = useState(0);
  const [months, setMonths] = useState(1);

  const calculateRevenue = () => {
    const vmCost = vmCount * 5;
    const dbCost = dbCount * 10;
    const cloudflareCost = cloudflareCount * 30;
    const monthlyRevenue = monthlyUsers * 3;
    const yearlyRevenue = yearlyUsers * 30;

    const totalCost = (vmCost + dbCost + cloudflareCost) * months;
    const totalRevenue = (monthlyRevenue + yearlyRevenue / 12) * months;

    return totalRevenue - totalCost;
  };

  return (
    <div className="max-w-lg mx-auto p-6 bg-white shadow-md rounded-lg">
      <h1 className="text-2xl font-bold text-center mb-6">Revenue Calculator</h1>

      <div className="mb-4">
        <label className="block text-gray-700 mb-1">
          Máy ảo (5$/tháng):
        </label>
        <input
          type="number"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={vmCount}
          onChange={(e) => setVmCount(parseInt(e.target.value) || 0)}
        />
      </div>

      <div className="mb-4">
        <label className="block text-gray-700 mb-1">
          DB (10$/tháng):
        </label>
        <input
          type="number"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={dbCount}
          onChange={(e) => setDbCount(parseInt(e.target.value) || 0)}
        />
      </div>

      <div className="mb-4">
        <label className="block text-gray-700 mb-1">
          Cloudflare (30$/tháng):
        </label>
        <input
          type="number"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={cloudflareCount}
          onChange={(e) => setCloudflareCount(parseInt(e.target.value) || 0)}
        />
      </div>

      <div className="mb-4">
        <label className="block text-gray-700 mb-1">
          Monthly Users (3$/user):
        </label>
        <input
          type="number"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={monthlyUsers}
          onChange={(e) => setMonthlyUsers(parseInt(e.target.value) || 0)}
        />
      </div>

      <div className="mb-4">
        <label className="block text-gray-700 mb-1">
          Yearly Users (30$/user):
        </label>
        <input
          type="number"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={yearlyUsers}
          onChange={(e) => setYearlyUsers(parseInt(e.target.value) || 0)}
        />
      </div>

      <div className="mb-4">
        <label className="block text-gray-700 mb-1">
          Số tháng:
        </label>
        <input
          type="number"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={months}
          onChange={(e) => setMonths(parseInt(e.target.value) || 0)}
        />
      </div>

      <div className="mt-6 p-4 bg-gray-100 rounded-md text-center">
        <h2 className="text-xl font-semibold">Doanh thu: ${calculateRevenue()}</h2>
      </div>
    </div>
  );
}